import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
// dono css files same hai koi ek bhi use ki hoti to bhi chalta
import "./ShopParatha.css";
import "./CategoryProducts.css";

const Z_API = "https://cyberathon.com/streekatha/API/index.php/Master_controller";
const PAGE_SIZE = 24;

/* Ye 2 slug category nahi hain, special hain */
const SPECIAL = {
  "all-sarees": { title: "All Sarees", params: {} },
  "new-arrivals": { title: "New Arrivals", params: { is_new: 1 } },
};

const SORT_OPTIONS = [
  { value: "featured", label: "Featured" },
  { value: "price-asc", label: "Price, low to high" },
  { value: "price-desc", label: "Price, high to low" },
  { value: "name-asc", label: "Alphabetically, A-Z" },
  { value: "name-desc", label: "Alphabetically, Z-A" },
];

const FILTER_OPTIONS = [
  { value: "all", label: "All prices" },
  { value: "under-2000", label: "Under Rs. 2,000" },
  { value: "2000-3000", label: "Rs. 2,000 - 3,000" },
  { value: "above-3000", label: "Above Rs. 3,000" },
  { value: "sale", label: "On sale" },
];

const formatPrice = (value) =>
  `Rs. ${Number(value).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const getPageList = (current, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("dots-left");
  for (let p = start; p <= end; p++) pages.push(p);
  if (end < total - 1) pages.push("dots-right");
  pages.push(total);
  return pages;
};

const svg = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};
const ChevronDown = () => (<svg {...svg} width="14" height="14"><path d="M6 9l6 6 6-6" /></svg>);
const ArrowLeft = () => (<svg {...svg} width="16" height="16"><path d="M15 6l-6 6 6 6" /></svg>);
const ArrowRight = () => (<svg {...svg} width="16" height="16"><path d="M9 6l6 6-6 6" /></svg>);
const PlusIcon = () => (<svg {...svg} width="16" height="16"><path d="M12 5v14M5 12h14" /></svg>);
const MinusIcon = () => (<svg {...svg} width="16" height="16"><path d="M5 12h14" /></svg>);
const CloseIcon = () => (<svg {...svg} width="22" height="22"><path d="M5 5l14 14M19 5L5 19" /></svg>);
const StarIcon = ({ filled }) => (
  <svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true" fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round">
    <path d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9L12 16.9l-5.2 2.8 1-5.9-4.3-4.1 5.9-.8L12 3.5z" />
  </svg>
);

const BarDropdown = ({ label, value, options, onChange, showChevron = true, widthClass = "" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  return (
    <div className={`shopcssparatha-dd ${widthClass}`} ref={ref}>
      <button type="button" className="shopcssparatha-dd-btn" aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen((p) => !p)}>
        <span>{label}</span>
        {showChevron && (
          <span className={`shopcssparatha-dd-chev ${open ? "shopcssparatha-dd-chev-open" : ""}`}>
            <ChevronDown />
          </span>
        )}
      </button>
      {open && (
        <ul className="shopcssparatha-dd-menu" role="listbox">
          {options.map((opt) => (
            <li key={opt.value}>
              <button
                type="button"
                role="option"
                aria-selected={value === opt.value}
                className={`shopcssparatha-dd-opt ${value === opt.value ? "shopcssparatha-dd-opt-active" : ""}`}
                onClick={() => { onChange(opt.value); setOpen(false); }}
              >
                {opt.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

/* ------------------------------------------------------------------
   Listing: slug / subcategory badalte hi key se naya instance banta hai,
   isliye sort, filter, page apne aap reset ho jate hain.
------------------------------------------------------------------- */
const Listing = ({ slug, subId }) => {
  const navigate = useNavigate();
  const special = SPECIAL[slug];

  const [sort, setSort] = useState("featured");
  const [filter, setFilter] = useState("all");
  const [page, setPage] = useState(1);

  const [products, setProducts] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [title, setTitle] = useState(special ? special.title : "");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [cartOpen, setCartOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [showNote, setShowNote] = useState(false);
  const [orderNote, setOrderNote] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /* ---------------- API se products ---------------- */
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(false);

    const params = { page, limit: PAGE_SIZE, sort, filter: filter === "all" ? "" : filter };
    if (special) Object.assign(params, special.params);
    else params.category_slug = slug;
    if (subId) params.subcategory_id = subId;

    axios
      .get(`${Z_API}/list_z_products`, { params })
      .then((res) => {
        if (cancelled) return;
        const d = res.data;
        if (d.status === "true") {
          setProducts(d.data || []);
          setTotal(d.total || 0);
          setTotalPages(Math.max(1, d.total_pages || 1));
          if (!special && d.category_name) setTitle(d.category_name);
        } else {
          setProducts([]);
          setTotal(0);
        }
      })
      .catch(() => !cancelled && setError(true))
      .finally(() => !cancelled && setLoading(false));

    return () => { cancelled = true; };
  }, [slug, subId, sort, filter, page, special]);

  /* ---------------- Cart drawer ---------------- */
  useEffect(() => {
    if (!cartOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && setCartOpen(false);
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener("keydown", onKey);
    };
  }, [cartOpen]);

  const handleAddToCart = (p) => {
    setCartItems((prev) => {
      const exists = prev.find((i) => i.id === p.id);
      if (exists) return prev.map((i) => (i.id === p.id ? { ...i, qty: i.qty + 1 } : i));
      return [...prev, { id: p.id, name: p.name, price: Number(p.current_price), image: p.image_url, qty: 1 }];
    });
    setCartOpen(true);
  };

  const changeQty = (id, delta) =>
    setCartItems((prev) => prev.map((i) => (i.id === id ? { ...i, qty: Math.max(1, i.qty + delta) } : i)));
  const removeItem = (id) => setCartItems((prev) => prev.filter((i) => i.id !== id));
  const subtotal = cartItems.reduce((s, i) => s + i.price * i.qty, 0);

  const goToPage = (p) => {
    if (p < 1 || p > totalPages || p === page) return;
    setPage(p);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const pageList = useMemo(() => getPageList(page, totalPages), [page, totalPages]);

  return (
    <section className="shopcssparatha-section">
      <h1 className="shopcssparatha-sr-only">{title || "Products"}</h1>

      {/* ---------------- STICKY TOP BAR ---------------- */}
      <div className="shopcssparatha-topbar">
        <div className="shopcssparatha-count">
          {total} {total === 1 ? "product" : "products"}
        </div>
        <BarDropdown label="Sort by" value={sort} options={SORT_OPTIONS} onChange={(v) => { setSort(v); setPage(1); }} widthClass="shopcssparatha-dd-sort" />
        <BarDropdown label="Filter" value={filter} options={FILTER_OPTIONS} onChange={(v) => { setFilter(v); setPage(1); }} showChevron={false} widthClass="shopcssparatha-dd-filter" />
      </div>

      {/* ---------------- GRID ---------------- */}
      <div className="shopcssparatha-content">
        {error ? (
          <p className="shopcssparatha-empty">Something went wrong. Please try again.</p>
        ) : loading && products.length === 0 ? (
          <p className="shopcssparatha-empty">Loading...</p>
        ) : products.length === 0 ? (
          <p className="shopcssparatha-empty">No products found.</p>
        ) : (
          <div className="shopcssparatha-grid" style={{ opacity: loading ? 0.6 : 1, transition: "opacity .2s" }}>
            {products.map((p) => {
              const link = `/product/${p.slug}`;
              const showStars = Number(p.reviews_count) > 0;
              return (
                <article className="shopcssparatha-card" key={p.id}>
                  <div className="shopcssparatha-media">
                    <Link to={link} className="shopcssparatha-media-link" aria-label={p.name}>
                      {p.image_url && (
                        <img src={p.image_url} alt={p.name} className="shopcssparatha-img shopcssparatha-img-main" loading="lazy" draggable={false} />
                      )}
                      {p.hover_image_url && (
                        <img src={p.hover_image_url} alt="" className="shopcssparatha-img shopcssparatha-img-hover" loading="lazy" draggable={false} />
                      )}
                    </Link>

                    {/* {p.save_percent > 0 && <span className="shopcssparatha-save">SAVE {p.save_percent}%</span>} */}

                    <button type="button" className="shopcssparatha-plus" aria-label={`Add ${p.name} to cart`} onClick={() => handleAddToCart(p)}>
                      <PlusIcon />
                    </button>
                  </div>

                  <Link to={link} className="shopcssparatha-body">
                    <h3 className="shopcssparatha-name">{p.name}</h3>
                    <p className="shopcssparatha-price">
                      <span>{formatPrice(p.current_price)}</span>
                      {Number(p.old_price) > Number(p.current_price) && <s>{formatPrice(p.old_price)}</s>}
                    </p>
                    {showStars && (
                      <div className="shopcssparatha-rating" aria-label={`Rated ${p.rating} out of 5`}>
                        <span className="shopcssparatha-stars">
                          {[1, 2, 3, 4, 5].map((n) => (
                            <StarIcon key={n} filled={n <= Math.round(Number(p.rating))} />
                          ))}
                        </span>
                        <span className="shopcssparatha-reviews">({p.reviews_count})</span>
                      </div>
                    )}
                  </Link>
                </article>
              );
            })}
          </div>
        )}

        {/* ---------------- PAGINATION ---------------- */}
        {totalPages > 1 && (
          <nav className="shopcssparatha-pagination" aria-label="Pagination">
            <button type="button" className="shopcssparatha-page-btn" aria-label="Previous page" disabled={page === 1} onClick={() => goToPage(page - 1)}>
              <ArrowLeft />
            </button>
            {pageList.map((item) =>
              typeof item === "string" ? (
                <span key={item} className="shopcssparatha-page-dots">...</span>
              ) : (
                <button
                  key={item}
                  type="button"
                  className={`shopcssparatha-page-btn ${item === page ? "shopcssparatha-page-active" : ""}`}
                  aria-current={item === page ? "page" : undefined}
                  onClick={() => goToPage(item)}
                >
                  {item}
                </button>
              )
            )}
            <button type="button" className="shopcssparatha-page-btn" aria-label="Next page" disabled={page === totalPages} onClick={() => goToPage(page + 1)}>
              <ArrowRight />
            </button>
          </nav>
        )}
      </div>

      {/* ---------------- CART DRAWER ---------------- */}
      <div className={`shopcssparatha-overlay ${cartOpen ? "shopcssparatha-open" : ""}`} onClick={() => setCartOpen(false)} aria-hidden={!cartOpen} />

      <aside className={`shopcssparatha-drawer ${cartOpen ? "shopcssparatha-open" : ""}`} aria-label="Cart" aria-hidden={!cartOpen}>
        <div className="shopcssparatha-drawer-head">
          <h4>Cart</h4>
          <button type="button" className="shopcssparatha-drawer-close" aria-label="Close cart" onClick={() => setCartOpen(false)} tabIndex={cartOpen ? 0 : -1}>
            <CloseIcon />
          </button>
        </div>

        <div className="shopcssparatha-drawer-body">
          {cartItems.length === 0 ? (
            <p className="shopcssparatha-cart-empty">Your cart is empty.</p>
          ) : (
            cartItems.map((item) => (
              <div className="shopcssparatha-cart-item" key={item.id}>
                <img src={item.image} alt={item.name} />
                <div className="shopcssparatha-cart-info">
                  <p className="shopcssparatha-cart-name">{item.name}</p>
                  <p className="shopcssparatha-cart-price">{formatPrice(item.price)}</p>
                  <div className="shopcssparatha-cart-actions">
                    <div className="shopcssparatha-qty">
                      <button type="button" aria-label="Decrease quantity" onClick={() => changeQty(item.id, -1)}><MinusIcon /></button>
                      <span>{item.qty}</span>
                      <button type="button" aria-label="Increase quantity" onClick={() => changeQty(item.id, 1)}><PlusIcon /></button>
                    </div>
                    <button type="button" className="shopcssparatha-remove" onClick={() => removeItem(item.id)}>Remove</button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        <div className="shopcssparatha-drawer-foot">
          <button type="button" className="shopcssparatha-note-toggle" onClick={() => setShowNote((p) => !p)}>Add order note</button>
          {showNote && (
            <textarea className="shopcssparatha-note" rows={3} placeholder="Write your note here..." value={orderNote} onChange={(e) => setOrderNote(e.target.value)} />
          )}
          <p className="shopcssparatha-tax">Taxes and shipping calculated at checkout</p>
          <div className="shopcssparatha-subtotal">
            <strong>Subtotal:</strong>
            <strong>{formatPrice(subtotal)}</strong>
          </div>
          <button
            type="button"
            className="shopcssparatha-checkout"
            onClick={() => { setCartOpen(false); navigate("/bag"); }}
            disabled={cartItems.length === 0}
          >
            Checkout
          </button>
        </div>
      </aside>
    </section>
  );
};

const CategoryProducts = () => {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const subId = searchParams.get("subcategory") || "";

  return <Listing key={`${slug}-${subId}`} slug={slug} subId={subId} />;
};

export default CategoryProducts;